import React, { useState } from 'react';
import './FormularioNuevaBotella.css';
import { toast } from 'react-toastify';

const FormularioNuevaBotella = ({ user, onClose, onGuardar }) => {
  const [tipoGas, setTipoGas] = useState('R404');
  const [kgTotal, setKgTotal] = useState('');

  const API_URL = process.env.REACT_APP_API_URL || '';

  const handleGuardar = async () => {
    if (!kgTotal) {
      toast.warn('Introduce el peso total de la botella');
      return;
    }

    const fechaAlta = new Date().toISOString().slice(0, 10);
    const almacen = user?.usuario;

    const res = await fetch(`${API_URL}/api/nueva-botella`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        tipoGas,
        kgTotal: parseFloat(kgTotal) * 100, // se guarda en gramos
        almacen,
        fechaAlta
      })
    });

    if (res.ok) {
      toast.success('✅ Botella registrada correctamente');
      onGuardar(true);
    } else {
      toast.error('❌ Error al registrar la botella');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>➕ Nueva Botella de Gas</h3>

        <div className="form-group">
          <label>Tipo de Gas</label>
          <select value={tipoGas} onChange={(e) => setTipoGas(e.target.value)}>
          <option value="R454C">R454C</option>
          <option value="R452">R452</option>
            <option value="R449">R449</option>
            <option value="R410">R410</option>
            <option value="R407">R407</option>
            <option value="R404">R404</option>
            <option value="R404 Reg">R404 regenerado</option>
            <option value="R134">R134</option>
            <option value="R290">R290</option>
            <option value="Co2">Co2</option>
          </select>
        </div>

        <div className="form-group">
          <label>Peso total (kg)</label>
          <input
            type="number"
            value={kgTotal}
            onChange={(e) => setKgTotal(e.target.value)}
            min="0"
            step="0.01"
            placeholder="Ej: 20.00"
          />
        </div>

        <div className="botones-formulario">
          <button onClick={handleGuardar} className="btn-guardar">Guardar</button>
          <button onClick={onClose} className="btn-cancelar">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default FormularioNuevaBotella;
